import styles from "./styles/FAQ.module.css";
import { Navbar } from "./Navbar";
import { FAQContent } from "./components/FAQ/FAQContent";
import { Footer } from "./Footer";
import React, { useCallback, useEffect, useState } from "react";
import { baseAxios } from "./apis";

export const FAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const fetchFaq = useCallback(async (retries = 0) => {
    try {
      const response = await baseAxios.get(`/api/faq`);
      setFaqs(response.data);
    } catch (err) {
      if (retries < 5) {
        fetchFaq(retries + 1);
      }
    }
  }, []);
  useEffect(() => {
    fetchFaq();
  }, [fetchFaq]);
  return (
    <div className={styles.faq}>
      <Navbar />
      <FAQContent faqs={faqs} />
    </div>
  );
};
